import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/auth/services/auth.guard';
import { PermissionGuard } from './modules/guard/permission.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    redirectTo: 's',
    pathMatch: 'full',
  },
  {
    path: 's',
    loadChildren: () =>
      import('./modules/supplier/supplier.module').then(
        (m) => m.SupplierModule
      ),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: '',
    // canActivate: [AuthGuard, PermissionGuard],
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./theme/layout/layout.module').then((m) => m.LayoutModule),
  },
  // { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
